<template>
    <v-bottom-sheet v-model="$store.state.showCartDialogStatus" hide-overlay elevation="0">
      <v-card color="white" rounded="t-xl">
        <v-card-text class="px-1 pt-0">
          <v-row justify="center">
            <v-col cols="12" md="6">
              <v-card variant="text"  class="d-flex flex-column" style="max-height: 90vh;">
                <v-card-actions  class="sticky top-0 bg-white z-10">
                  <h3>{{ $t('cart') }}</h3>
                  <v-spacer></v-spacer>
                  <v-btn icon @click="$store.commit('setShowCartDialogStatusDialogStatus', false)">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-card-actions>
                <v-divider></v-divider>
                <v-card-text class="px-1 overflow-y-auto" style="flex-grow: 1; min-height: 0;">
                    <v-card class="pa-4 border-b-sm border-solid mb-1" color="white" variant="flat"  v-for="(cartItem,index) in $store.state.cart" :key="`cartItem`+index">
                        <div class="d-flex justify-space-between">
                            <img v-if="cartItem.image.length > 0" class="service-img" :src="$store.state.fileBaseUrl+cartItem.image"/>
                            <div style="flex-grow: 1;" class="pr-3 d-flex flex-column justify-space-between">
                                <div>
                                  <h4>
                                      {{ cartItem.title }}
                                      <span v-if="!!cartItem.variable && cartItem.variable.name"
                                          class="text-body-2 text-grey-darken-3">
                                          ({{ cartItem.variable.name }})
                                      </span>
                                  </h4>
                                  <ul style="list-style: none;" class="my-2" v-if="!!cartItem.addons && cartItem.addons.length > 0">
                                      <li v-for="(addon,index) in cartItem.addons" :key="`addon`+index" class="text-grey">
                                          <v-icon>mdi-plus-circle</v-icon>
                                          {{ addon.title }}
                                          <span v-if="addon.total > 1">
                                              ({{ addon.total }})
                                          </span>
                                      </li>
                                  </ul>
                                </div>
                                

                                <div class="d-flex justify-space-between align-center">
                                  <TotalControl
                                    @decrease="$store.commit('decreaseService', cartItem)"
                                    @increase="$store.commit('increaseService', cartItem)"
                                    @remove="$store.commit('removeService', cartItem)"
                                    :item="cartItem"/>
                                  <div class="text-caption">
                                    {{ $t('sum') }}:
                                    <strong>{{ new Intl.NumberFormat('fa-IR').format($store.getters.calcCartItemPrice(index)) }}</strong>
                                    {{ $t('rial') }}
                                  </div>
                                </div>
                            </div>
                        </div>
                    </v-card>
                </v-card-text>
                <v-card-actions class="sticky bottom-0 bg-white z-10">
                    <v-btn 
                        color="primary"
                        size="large"
                        block
                        variant="flat"
                        append-icon="mdi-chevron-left"
                        @click="$store.commit('setActivePage', 'order');$store.commit('setShowCartDialogStatusDialogStatus', false);"
                        >
                        {{ $t('submit_order') }}
                    </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-bottom-sheet>
</template>

<script>
    import TotalControl from '@/components/total_control.vue';

export default {
    name: "CartComponent",
    components: {
        TotalControl,
    },
    methods:{
      
    },
    
}
</script>